import { Button } from '@heroui/react';
import { FeatherIcon } from '../components/FeatherIcon';

/** The main-area notice for a CRM route the shell cannot show (no access, CRM down). */
export function CrmEmptyState({
  icon,
  title,
  body,
  action,
}: {
  icon: string;
  title: string;
  body: string;
  action?: { label: string; onPress: () => void };
}) {
  return (
    <div className="mobile-page-shell w-full px-6 py-6 min-w-0 flex flex-col" style={{ minHeight: 'calc(100 * var(--om-vh))' }}>
      <div
        className="flex-1 flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-[var(--om-border)] text-center px-6"
        style={{ background: 'repeating-linear-gradient(135deg,var(--om-surface) 0 10px,var(--om-panel) 10px 20px)' }}
      >
        <span className="w-11 h-11 rounded-full flex items-center justify-center" style={{ background: 'color-mix(in srgb, var(--om-accent) 16%, transparent)', color: 'var(--om-accent-3)' }}>
          <FeatherIcon name={icon} size={20} />
        </span>
        <h1 className="text-[15px] font-semibold text-[var(--om-text)]">{title}</h1>
        <p className="text-[13px] text-[var(--om-sub)] max-w-[420px]">{body}</p>
        {action && (
          <Button variant="ghost" onPress={action.onPress} className="mt-2">
            {action.label}
          </Button>
        )}
      </div>
    </div>
  );
}
